/* @flow */
import OrganizationClassesTableContainer from 'organizations/containers/OrganizationClassesTableContainer.jsx';
import * as React from 'react';
import SmartTable from 'components/SmartTable.jsx';
import View from 'components/View.jsx';

import './styles/AdminClassesTable.scss';

const nameSorts = [
  { key: 'name_asc', name: 'Ascending' },
  { key: 'name_desc', name: 'Descending' },
];

const createdAtSorts = [
  { key: 'created_at_asc', name: 'Ascending' },
  { key: 'created_at_desc', name: 'Descending' },
];

const COLUMNS = [
  { key: 'name', name: 'Name', sorts: nameSorts },
  { key: 'owner', name: 'Owner' },
  { key: 'message_count', name: 'Announcements' },
  { key: 'participant_count', name: 'Participants' },
  { key: 'created_at', name: 'Date created', sorts: createdAtSorts },
];

const INITIAL_SORT = 'created_at_desc';

type Props = {
  orgId: number,
};

class AdminClassesTable extends React.Component<Props> {
  render() {
    const { orgId } = this.props;
    const namespace = `admin-class-list-${orgId}`;

    return (
      <View scroll>
        <SmartTable
          columns={COLUMNS}
          initialSort={INITIAL_SORT}
          namespace={namespace}
          searchPlaceholder="Search classes"
          withSearch
          data-test="smart-table">
          {({ query, sort }) => (
            <OrganizationClassesTableContainer
              organizationId={Number(orgId)}
              query={query}
              sort={sort}
            />
          )}
        </SmartTable>
      </View>
    );
  }
}

export default AdminClassesTable;
